export default __webpack_public_path__ + "static/media/graph-curve-up.3ac5889f.svg";